import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateSolarEnergy } from '../../redux/renewable_energy/solar_energy_actions';

const mapStateToProps = state => ({
  isDuplicating: state.renewableEnergy.solarEnergy.isDuplicating,
  errorMessage: state.renewableEnergy.solarEnergy.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateSolarEnergy(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/renewable_energy/SolarEnergyDuplicateModal.js